var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="chart_sec">\n    ';
 if ( navigation ) { 
__p+='\n    <a class="left carousel-control">\n        <span class="glyphicon glyphicon-chevron-left"></span>\n    </a>\n    ';
 } 
__p+='\n\n    <div class="no_data" style="width: 90%; height: 400px;">\n        <div style="position: absolute; top: 50%; transform: translateY(-50%);left: 0; right: 0;">No data available</div>\n    </div>\n    <div class="center-block chart_container" style="width: 90%; height: 400px;">\n\n    </div>\n    <input type="hidden" value="12" id="chart_image_value">\n    ';
 if ( navigation ) { 
__p+='\n    <a class="right carousel-control">\n        <span class="glyphicon glyphicon-chevron-right"></span>\n    </a>\n    ';
 } 
__p+='\n</div>';
}
return __p;
};
